import O1HD from "../../engines/gameEngine";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { PLATFORM_CODE } from "../../engines/services/ossService";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { FileKind } from "../../modes/define/FileKind";
import { MessageEventKind } from "../../modes/define/MessageEventKind";
import { UIKind } from "../../modes/define/UIKind";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import UserDataManage from "../../modes/normalMode/model/UserDataManage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class waterCourse extends cc.Component {

    @property(cc.Node)
    btnBiaoShi1: cc.Node = null;
    @property(cc.Node)
    btnBiaoShi2: cc.Node = null;
    @property(cc.Node)
    btnYaBiao1: cc.Node = null;
    @property(cc.Node)
    btnYaBiao2: cc.Node = null;

    @property({type:cc.Node,tooltip:"感叹号"})
    mark:cc.Node = null;
    @property({type:cc.Node})
    btnTakeCow:cc.Node = null;
    @property({type:cc.Node})
    btnBoastGuiFei:cc.Node = null;
    @property({type:cc.Node})
    btnTakeCow2:cc.Node = null;

    @property({type:cc.Node,tooltip:"救贵妃节点"})
    saveArchery:cc.Node = null;

    @property({type:cc.Node,tooltip:"李白节点"})
    liBaiNode:cc.Node = null;

    @property({type:cc.SpriteFrame,tooltip:"李白的图片"})
    libaiSps:cc.SpriteFrame[] = [];

    start(){
        this.btnBoastGuiFei.active = false;
        this.liBaiNode.active = false;
        O1HD.getModules().uiControlModule.hideLoading();
        this.refreshState();
        O1HD.on(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE, this.refreshState, this);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.WaterCourse);
    }

    refreshState() {

        this.btnTakeCow.active = false;
        this.btnTakeCow2.active = false;
        let gameData = NormalGameManager._instance.getGameData();
        // if (gameData.agreeCupidHelp2) {
            if (gameData.agreeTakeCow) {
                this.btnTakeCow2.active = true;
            } else {
                this.btnTakeCow.active = true;
            }
        // }

        if (gameData.wechatRecordPoint.includes('5034Finish') || 
            gameData.ariseLinks.includes('46')
        ) {
            this.btnBoastGuiFei.active = true;
            if (gameData.bFinishBoastGuiFei) {
                this.btnBoastGuiFei.getChildByName('mark').active = false;
            }
        }
        
        if (gameData.wechatRecordPoint.includes('5040Finish') && !gameData.bFinishHitRob) {
            this.btnBoastGuiFei.active = true;
            this.btnBoastGuiFei.getChildByName('mark').active = true;
        }
        
        this.btnBiaoShi1.active = false;
        this.btnBiaoShi2.active = false;
        if (gameData.wechatRecordPoint.includes('5035Finish')) {
            if (gameData.bEnterYabiao2) {
                this.btnBiaoShi2.active = true;
            } else {
                this.btnBiaoShi1.active = true;
            }
            // this.btnBoastGuiFei.active = true;
            // if (gameData.bFinishBoastGuiFei) {
            //     this.btnBoastGuiFei.getChildByName('mark').active = false;
            // }
        }

        this.btnYaBiao1.active = false;
        this.btnYaBiao2.active = false;

        if (gameData.wechatRecordPoint.includes('5036Finish')) {
            if (gameData.bEnterYabiao1) {
                this.btnYaBiao1.active = true;
            } else {
                this.btnYaBiao2.active = true;
            }
        }

        // let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        // let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        // if (matchMiaiData.bBridePrice) {
        //     this.markAni();
        //     return;
        // }

        let bExit = NormalGameManager._instance.getGameData().saveCupidFlag;
        if(NormalGameManager._instance.getGameData().isDeliveryWings){
            this.mark.active = false;
        }else if(bExit && O1HD.getServices().ossSrv.getPlatform() != PLATFORM_CODE.H5){
            this.mark.active = false;
        }else{
            let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
            let matchMiaiData = matchMiaiDataManage.matchMiaiData;
            if (matchMiaiData.bEndGame || matchMiaiData.bShowCupidArrow) {
                // this.markAni();
                this.mark.active = true;
            } else {
                this.mark.active = false;
            }
        }
        if (!gameData.bFinishHelpWife && gameData.bFinishHitRob) {
            this.mark.active = true;
        }
        
        if(gameData.isJoinTakeCow && !gameData.saveArcheryFlag){
            this.saveArcheryAni();
        }else{
            this.saveArchery.active = false;
        }

        let ishaveChat = ()=>{
            let people = NormalGameManager._instance.weChatManager.getOnePeopleById("华贵妃");
            let chats = people?.peopleChatLastLink;
            return chats?.find((item)=>{
                return item.chatsId == "5031";
            });
        }

        if((NormalGameManager._instance.getGameData().finishChatedIdM["5031"] || ishaveChat()) && NormalGameManager._instance.getGameData().liBaiGoodValue<100){
            this.liBaiNode.active = true;
        }
        let libaiSpNode:cc.Node = this.liBaiNode.getChildByName("spf_LiBai");
        let progressNode = libaiSpNode.getChildByName("progress");
        let progree:cc.ProgressBar = progressNode.getComponent(cc.ProgressBar);
        let progressLb:cc.Label = progressNode.getChildByName("labelValue").getComponent(cc.Label);
        progressLb.string = `${NormalGameManager._instance.getGameData().liBaiGoodValue} / 100`;
        progree.progress =  NormalGameManager._instance.getGameData().liBaiGoodValue/100;
        if(NormalGameManager._instance.getGameData().liBaiGoodValue <= 0){
            libaiSpNode.getComponent(cc.Sprite).spriteFrame = this.libaiSps[0];
        }else if(NormalGameManager._instance.getGameData().liBaiGoodValue <= 50){
            libaiSpNode.getComponent(cc.Sprite).spriteFrame = this.libaiSps[1];
            this.showLibaiChat("好诗句，这还有一幅画，你再作一首我便赋诗一篇");
        }else{
            libaiSpNode.getComponent(cc.Sprite).spriteFrame = this.libaiSps[2];
            this.showLibaiChat("少侠果然是同道中人,这首诗就赠与知音");
        }
    }

    showLibaiChat(chat:string){
        let libaiSpNode:cc.Node = this.liBaiNode.getChildByName("spf_LiBai");
        let chatNode:cc.Node = libaiSpNode.getChildByName("spr_chat_bg2");
        let chatLb:cc.Label = chatNode.getChildByName("label").getComponent(cc.Label);
        chatLb.string = chat;
        cc.tween(chatNode).to(0.2,{scale:1}).start();
    }

    hideLiBaiChat(){
        let libaiSpNode:cc.Node = this.liBaiNode.getChildByName("spf_LiBai");
        let chatNode:cc.Node = libaiSpNode.getChildByName("spr_chat_bg2");
        cc.tween(chatNode).to(0.2,{scale:0}).start();
    }

    saveArcheryAni(){
        this.saveArchery.active = true;
        let node:cc.Node = this.saveArchery.getChildByName("spr_chat_bg2");
        cc.Tween.stopAllByTarget(node);
        node.scale = 0;
        let tween = cc.tween(node).to(0.2,{scale:1}).delay(2).to(0.2,{scale:0}).delay(2);
        cc.tween(node).repeatForever(tween).start();
    }

    markAni(){
        let tween = cc.tween(this.mark).to(0.2,{angle:20,scale:1.1}).to(0.2,{angle:-20,scale:1});
        cc.tween(this.mark).repeatForever(tween).start();
    }

    onBtnHealBeriberi(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        // if (matchMiaiData.bBridePrice) {
        let gameData = NormalGameManager._instance.getGameData();

        if (!gameData.bFinishHelpWife && gameData.bFinishHitRob) {
            O1HD.getModules().uiControlModule.showLoading();
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.HelpWifeLayer1
                , null
                , null
                , null
                , null
                , false
            );
            return;
        }

        if (NormalGameManager._instance.getGameData().isDeliveryWings) {
            O1HD.getModules().uiControlModule.showMessageBox("屋子里空空的，什么都没有");
            return;
        }

        if(NormalGameManager._instance.getGameData().agreeCupidHelp2){
            O1HD.getModules().uiControlModule.showLoading();
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.CupidHelp3Layer
                , null
                , null
                , null
                , null
                , false
            );
            return;
        }      
        
        let bExit = gameData.saveCupidFlag;
        if(bExit){
            let curDay = NormalGameManager._instance.getCurrentDay();
            if (curDay >= (gameData.finishCupidLv1Time+1)) {
                O1HD.getModules().uiControlModule.showLoading();
                utilsView.openPopupLayerTwo(
                    FileKind.PrefabFilePath.CupidHelp2Layer
                    , null
                    , null
                    , null
                    , null
                    , false
                );
                return;
            }

            if (O1HD.getServices().ossSrv.getPlatform() != PLATFORM_CODE.H5) {
                O1HD.getModules().uiControlModule.showMessageBox("屋子里空空的，什么都没有");
                return;    
            }
        }
        
        if (!matchMiaiData.bEndGame && !matchMiaiData.bShowCupidArrow) {
            O1HD.getModules().uiControlModule.showMessageBox("屋子里空空的，什么都没有");
            return;
        }
        
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.healBeriberiStartLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    onBtnTakeCow(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.agreeTakeCow) {
            this.enterTakeCow();
        } else {
            utilsView.openEventLayer(
                null
                , {
                    id: '10'
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {
                        gameData.agreeTakeCow = true;
                        NormalGameManager._instance.writeGameData();
                        this.refreshState();
                        this.enterTakeCow();
                    }
                    , exitLayer: ()=> {
                        
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        }
    }

    enterTakeCow() {
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.takeCowGameLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    canClick:boolean = true;

    enterSaveArchery(){
        if(!this.canClick){
            return;
        }
        this.canClick = false;
        let fun = (node:cc.Node)=>{
            this.canClick = true;
        }
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.archeryStartLayer,null,null,null,fun
        );
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if(NormalGameManager._instance.getGameData().liBaiGoodValue >= 100 && NormalGameManager._instance.getGameData().isFirstLiBai){
            NormalGameManager._instance.setGameData({isFirstLiBai:false});
            utilsView.openEventLayer(
                null
                , {
                    id: '15'
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {

                    }
                    , exitLayer: ()=> {
                        
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        }
        this.node.destroy();
    }

    onClickBoastGuiFei() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.GuiFeiLayer
        );
    }

    onClickLiBai(){
        if(!this.canClick){
            return;
        }
        this.canClick = false;
        let fun = (node:cc.Node)=>{
            this.canClick = true;
        }
        if(NormalGameManager._instance.getGameData().liBaiGoodValue <= 0){
            utilsView.openEventLayer(
                null
                , {
                    id: '14'
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {
                        utilsView.openPopupLayerTwo(
                            FileKind.PrefabFilePath.libaiOneLayer,null,null,null,fun
                        );
                    }
                    , exitLayer: ()=> {
                        if (fun) {
                            fun(null);
                        }
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        }else if(NormalGameManager._instance.getGameData().liBaiGoodValue < 100){
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.libaiTwoLayer,null,null,null,fun
            );
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("已完成所有剧情");
        }
    }

    onClickBiaoshi1() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let gameData = NormalGameManager._instance.getGameData();
        utilsView.openEventLayer(
            null
            , {
                id: '19'
                , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                , saveData: ()=> {
                    gameData.bEnterYabiao2 = true;
                    NormalGameManager._instance.writeGameData();
                    this.refreshState();
                    this.openYaBiao2();
                }
                , exitLayer: ()=> {
                    
                }
            }
            , UI_Z_INDEX.DIALOG
        );
    }

    onClickBiaoshi2() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.openYaBiao2();
    }

    openYaBiao2() {
        utilsView.openPopupLayerTwo(FileKind.PrefabFilePath.dartStartPage);
    }

    onClickYaBiao1() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let gameData = NormalGameManager._instance.getGameData();
        utilsView.openEventLayer(
            null
            , {
                id: '21'
                , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                , saveData: ()=> {
                    gameData.bEnterYabiao1 = true;
                    NormalGameManager._instance.writeGameData();
                    this.refreshState();
                    this.openYaBiao1();
                }
                , exitLayer: ()=> {
                    
                }
            }
            , UI_Z_INDEX.DIALOG
        );
    }

    onClickYaBiao2() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.openYaBiao1();
    }

    openYaBiao1() {
        utilsView.openPopupLayerTwo(FileKind.PrefabFilePath.EscortGoods1Layer);
    }
}